@import (reference) '../../constants/spacing.module.less';

.weight-wrapper {
  margin-left: @space-8;
}
